import { render, staticRenderFns } from "./TableTotalTicketsFilaCategoriaStatus.vue?vue&type=template&id=67969287&"
import script from "./TableTotalTicketsFilaCategoriaStatus.vue?vue&type=script&lang=js&"
export * from "./TableTotalTicketsFilaCategoriaStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VAvatar,VCard,VDataTable,VImg,VProgressLinear})
